import axiosInstance from '../../api/axios';
import { API_ENDPOINTS } from '../../api/endpoints';

export async function fetchSubprocessNodeCatalog(cycleId, excludeProcessUuid) {
  const response = await axiosInstance.get(API_ENDPOINTS.getSubprocessNodeCatalog(cycleId), {
    params: excludeProcessUuid ? { excludeProcessUuid } : undefined,
  });
  if (response?.data?.success !== true) {
    throw new Error(response?.data?.error || 'Failed to load subprocess catalog');
  }
  return Array.isArray(response.data.processes) ? response.data.processes : [];
}

export async function fetchFlowchartSubprocessLinks(flowchartVersionId) {
  const response = await axiosInstance.get(
    API_ENDPOINTS.getFlowchartSubprocessLinks(flowchartVersionId)
  );
  if (response?.data?.success !== true) {
    throw new Error(response?.data?.error || 'Failed to load subprocess links');
  }
  return Array.isArray(response.data.links) ? response.data.links : [];
}

export async function fetchIncomingFlowchartSubprocessLinks(processUuid) {
  const response = await axiosInstance.get(
    API_ENDPOINTS.getIncomingFlowchartSubprocessLinks(processUuid)
  );
  if (response?.data?.success !== true) {
    throw new Error(response?.data?.error || 'Failed to load incoming subprocess links');
  }
  return Array.isArray(response.data.links) ? response.data.links : [];
}

export async function createFlowchartSubprocessLinks({
  flowchartVersionId,
  sourceNodeId,
  targets,
}) {
  const response = await axiosInstance.post(API_ENDPOINTS.createFlowchartSubprocessLinks, {
    flowchart_version_id: flowchartVersionId,
    source_node_id: sourceNodeId,
    targets: targets.map((target) => ({
      target_process_id: target.targetProcessId,
      target_node_id: target.targetNodeId,
    })),
  });
  if (response?.data?.success !== true) {
    throw new Error(response?.data?.error || 'Failed to create subprocess links');
  }
  return response.data;
}

export async function deleteFlowchartSubprocessLink(linkId) {
  const response = await axiosInstance.delete(
    API_ENDPOINTS.deleteFlowchartSubprocessLink(linkId)
  );
  if (response?.data?.success !== true) {
    throw new Error(response?.data?.error || 'Failed to delete subprocess link');
  }
  return response.data;
}

export function formatSubprocessNodeLabel(node) {
  const description = String(node?.nodeDescription || '').trim() || 'Untitled step';
  const actor = String(node?.actor || '').trim();
  return actor ? `${description} · ${actor}` : description;
}

export function formatSubprocessTargetOption(process, node) {
  const sequence =
    Number.isInteger(Number(process?.sequence)) && Number(process.sequence) >= 1
      ? String(process.sequence).padStart(2, '0')
      : '—';
  const processLabel = process?.processId || process?.processUuid || 'Process';
  return `${sequence} · ${processLabel} · ${formatSubprocessNodeLabel(node)}`;
}
